var chunkMapping = {
	"205": [
		60205
	],
	"543": [
		50543
	],
	"780": [
		780
	],
	"1271": [
		41271
	],
	"1531": [
		31531
	],
	"1625": [
		71625
	],
	"2122": [
		2122
	],
	"2340": [
		82340
	],
	"2812": [
		2812
	],
	"4222": [
		94222
	],
	"4340": [
		44340
	],
	"4652": [
		4652
	],
	"4917": [
		64917
	],
	"5845": [
		45845
	],
	"5962": [
		55962
	],
	"6609": [
		96609
	],
	"7149": [
		79530
	],
	"7303": [
		47303
	],
	"7696": [
		47696
	],
	"7734": [
		37734
	],
	"7745": [
		27745
	],
	"8419": [
		38419
	],
	"8440": [
		48440
	],
	"8556": [
		88556
	],
	"8722": [
		18722
	],
	"8846": [
		28846
	],
	"8939": [
		18939
	],
	"9188": [
		9188
	],
	"9408": [
		19408
	],
	"9418": [
		9418
	],
	"9448": [
		49448
	],
	"9545": [
		39545
	]
};
var idToExternalAndNameMapping = {
	"780": [
		"default",
		"./Dashboard",
		89846
	],
	"2122": [
		"default",
		"./CreateBill",
		68566
	],
	"2812": [
		"default",
		"./Insurance4",
		54519
	],
	"4652": [
		"default",
		"./Seller",
		68566
	],
	"9188": [
		"default",
		"./Buyerinfo",
		77206
	],
	"9418": [
		"default",
		"./Insurance2",
		54519
	],
	"18722": [
		"default",
		"./BuyerForm3",
		54519
	],
	"18939": [
		"default",
		"./Buyers",
		77206
	],
	"19408": [
		"default",
		"./Reconciliation",
		77206
	],
	"27745": [
		"default",
		"./BuyerForm8",
		54519
	],
	"28846": [
		"default",
		"./EditBill",
		68566
	],
	"31531": [
		"default",
		"./BuyerForm2",
		54519
	],
	"37734": [
		"default",
		"./BuyerForm7",
		54519
	],
	"38419": [
		"default",
		"./Insurance3",
		54519
	],
	"39545": [
		"default",
		"./ReconciliationBill",
		68566
	],
	"41271": [
		"default",
		"./Collections",
		89846
	],
	"44340": [
		"default",
		"./BuyerForm5",
		54519
	],
	"45845": [
		"default",
		"./Bills",
		68566
	],
	"47303": [
		"default",
		"./Dashboard",
		68566
	],
	"47696": [
		"default",
		"./CreateInvoice",
		77206
	],
	"48440": [
		"default",
		"./Invoice",
		77206
	],
	"49448": [
		"default",
		"./Sellerinfo",
		68566
	],
	"50543": [
		"default",
		"./BuyerForm6",
		54519
	],
	"55962": [
		"default",
		"./Sellerinfo2",
		68566
	],
	"60205": [
		"default",
		"./EditInvoice",
		89846
	],
	"64917": [
		"default",
		"./Payments",
		89846
	],
	"71625": [
		"default",
		"./Buyer",
		54519
	],
	"79530": [
		"default",
		"./BuyerForm4",
		54519
	],
	"82340": [
		"default",
		"./EditInvoice",
		77206
	],
	"88556": [
		"default",
		"./App",
		77206
	],
	"94222": [
		"default",
		"./Buyerinfo2",
		77206
	],
	"96609": [
		"default",
		"./Insurance1",
		54519
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}